<template>
    <div>
        <span
            class="ml-2 action-icon"
            @click="showDeleteBounceModal(bounce)"
            @shown="onModalShown"
        >
            <font-awesome-icon :icon="['fas', 'trash']" />
        </span>
        <modal
            :id="deleteBounceModalId"
            title="Delete bounce"
            @ok="deleteBounce"
        >
            <p>Are you sure you want to delete this guest email bounce?</p>
        </modal>
    </div>
</template>

<script>
import API from '../../../../api';
import Modal from '../../../generic/modal/modal.vue';
import { COMMUNICATION_ACTION_BOUNCE_DELETE_ENDPOINT } from '../../../../endpoints';

export default {
    components: { Modal },
    data() {
        return { deleteBounceModalId: null, bounce: null };
    },
    created() {
        this.bounce = this.params.data;
    },
    methods: {
        showDeleteBounceModal(bounce) {
            this.deleteBounceModalId = 'delete-bounce-modal' + bounce.id;
            this.$nextTick(() => {
                return this.$bvModal.show(this.deleteBounceModalId);
            });
        },
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        async deleteBounce() {
            try {
                await API.delete(
                    COMMUNICATION_ACTION_BOUNCE_DELETE_ENDPOINT(this.bounce.id)
                );
                this.params.update();
            } catch {
                this.errorToast({ text: 'Could not delete bounce.' });
            }
        },
    },
};
</script>

<style lang="scss">
.action-icon {
    cursor: pointer;
    color: #6c757d;
    &:hover {
        opacity: 0.8;
    }
}
</style>